import { render } from "./event.vue?vue&type=template&id=4b2ee15a&lang=pug"
import script from "./event.vue?vue&type=script&lang=js"
export * from "./event.vue?vue&type=script&lang=js"

import "./event.vue?vue&type=style&index=0&id=4b2ee15a&lang=scss"

import exportComponent from "/Users/matejglasnak/gitrepo/jandl-taskmanager-app/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__